import axios from '@axios'

const PREFIX = '/documentos'

export default {

  getDocumentos(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getDocumentosResumidos(filtro) {
    return axios.post(`${PREFIX}/resumido`, filtro)
  },

  getDocumento(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateDocumento(id, documento) {
    return axios.put(`${PREFIX}/${id}`, documento)
  },

  createDocumento(documento) {
    return axios.post(`${PREFIX}/add`, documento)
  },

  deleteDocumento(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },
}
